import {useMemo} from "react";

interface Props {
    search?: string
    text: string
    onClick?: () => void
}

export function Highlighter ({search, onClick, text}:Props) {
    const index = useMemo(() => {
        if(!text || !search) {
            return -1;
        }
        return text.toLowerCase().indexOf(search.toLowerCase());
    }, [search, text]);

    const parts = useMemo(() => {
        if(index === -1) {
            return undefined;
        }
        return [
            text.substring(0, index),
            text.substring(index, index + search!.length),
            text.substring(index + search!.length)
        ]
    }, [text, search, index])
    if(index === -1) {
        return <span onClick={onClick}>{text}</span>;
    }
    return <span onClick={onClick}>{parts![0]}<span className={"filter-highlight"}>{parts![1]}</span>{parts![2]}</span>
}